// extracted by mini-css-extract-plugin
module.exports = {"Container":"Loader_Container__1_orw","RouterLoaderAnimation":"Loader_RouterLoaderAnimation__30FAD","Spinner":"Loader_Spinner__2bOEY","SpinnerEl":"Loader_SpinnerEl__VOvb_"};